import type { PropsWithChildren, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import IconButton from '@mui/material/IconButton';
import { CloseIcon } from '@/icons';
import { classes } from './utils';

interface DialogTitleProps extends PropsWithChildren {
  icon?: ReactNode;
  title?: string | ReactNode;
  subtitle?: string;
  className?: string;
  actions?: ReactNode;
  onClose?: () => void;
}

export default function DialogTitle({
  icon,
  title,
  subtitle,
  className,
  actions,
  children,
  onClose,
  ...props
}: DialogTitleProps) {
  const renderTitles = () => {
    return (
      <>
        {!!title && (
          <h1 className={classes.title}>
            {icon}
            {title}
          </h1>
        )}
        {!!subtitle && <h2 className={classes.subtitle}>{subtitle}</h2>}
      </>
    );
  };
  if (!actions && !onClose) {
    return (
      <div className={twMerge(classes.titles, className)} {...props}>
        {renderTitles()}
      </div>
    );
  }
  return (
    <div
      className={twMerge(classes.titles, classes.closeButtonWrapper, className)}
      {...props}>
      <div className={classes.closeButtonTitles}>{renderTitles()}</div>
      <div className={classes.actionsWrapper}>
        {actions}
        {onClose && (
          <IconButton
            className={classes.closeButton}
            aria-label="close"
            onClick={onClose}>
            <CloseIcon />
          </IconButton>
        )}
      </div>
    </div>
  );
}
